export default __webpack_public_path__ + "static/skull_b.6c9a03b2b0b123db1614213ad0a1c557.png";